import { PropsWithChildren, FC, useMemo } from 'react'
import { Tag } from 'antd'

import Box from '~/core/Box'
import Tooltip from '~/core/Tooltip'
import SecurePlusIcon from '~/components/SecurePlusIcon'
import colors from '~/styles/_colors.css'

import { getAdminJobRequestsQuality_adminJobRequests_items as JobRequestType } from './__generated__/getAdminJobRequestsQuality'
import { getInspectionStatusTag, getAllProcesses } from './logic'

export const InspectionStatusTag: FC<
    PropsWithChildren<{
        reportState: string
    }>
> = ({ reportState }) => {
    const tag = getInspectionStatusTag(reportState)

    return <Tag color={tag.color}>{tag.title}</Tag>
}

export const ProcessNames: FC<
    PropsWithChildren<{
        jobRequest: JobRequestType | undefined
    }>
> = ({ jobRequest }) => {
    const [first, ...rest] = useMemo(
        () => getAllProcesses(jobRequest),
        [jobRequest],
    )
    const nameList = rest.join(', ')

    return first ? (
        <Box direction="col">
            {first}
            <Tooltip
                title={nameList}
                style={{
                    width: '30px',
                }}
                trigger="hover"
                placement="bottomLeft"
            >
                {rest?.length > 0 ? (
                    <small>{`Show ${rest?.length} more`}</small>
                ) : (
                    <Box />
                )}
            </Tooltip>
        </Box>
    ) : (
        <Box />
    )
}

export const Priority: FC<
    PropsWithChildren<{ jobRequest: JobRequestType }>
> = ({ jobRequest }) => {
    const priority = jobRequest?.priority || ''
    const formattedPriority =
        priority.charAt(0).toUpperCase() + priority.slice(1).toLowerCase()

    return <Box>{formattedPriority}</Box>
}

export const Payout: FC<
    PropsWithChildren<{
        totalAmount: number
    }>
> = ({ totalAmount }) => {
    return <Box>${totalAmount.toFixed(2)}</Box>
}

export const ProjectName: FC<
    PropsWithChildren<{
        isSecurePlus: boolean
        platformProjectName: string | null
    }>
> = ({ isSecurePlus, platformProjectName }) => {
    if (!platformProjectName) {
        return <span>-</span>
    }

    return (
        <Box>
            {isSecurePlus && (
                <SecurePlusIcon iconSize="14px" iconColor={colors.success} />
            )}
            {platformProjectName}
        </Box>
    )
}
